import { render } from "./LogoutForm.vue?vue&type=template&id=3f1a513d"
import script from "./LogoutForm.vue?vue&type=script&lang=js"
export * from "./LogoutForm.vue?vue&type=script&lang=js"
script.render = render

export default script